import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import { trackEvent } from '../../tools/eventTracking';
import { ON_TH_CLICK, RAW, TH_DECORATOR, TH_PROPS, TH_TOOLTIP } from '../common';
var NameToValue = {
  ascend: 1,
  descend: -1,
  disordered: null
};
var ValueToName = {
  1: 'ascend',
  '-1': 'descend'
};
var multipleText = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
export default function Sorter(_ref, _ref2) {
  var mapColumns = _ref.mapColumns,
      change = _ref.change;
  var globalSortDirections = _ref2.sortDirections;
  return {
    columns: mapColumns(function (column) {
      var _ref4;

      var title = column.title,
          sorter = column.sorter,
          _column$sortDirection = column.sortDirections,
          sortDirections = _column$sortDirection === void 0 ? globalSortDirections : _column$sortDirection,
          sortOrder = column.sortOrder,
          _column$onSort = column.onSort,
          onSort = _column$onSort === void 0 ? function () {} : _column$onSort;

      if (!sorter) {
        return null;
      }

      var sortOrderValue = NameToValue[sortOrder] || null;

      var _ref3 = sorter === true ? {} : sorter,
          multiple = _ref3.multiple;

      var enabledSortDirections = sortDirections.map(function (name) {
        return NameToValue[name];
      }); // 启用的排序值

      var enabledSortDirectionsSet = new Set(enabledSortDirections); // 启用的排序set

      function triggerChange(nextOrderValue, triggerName) {
        var orderName = ValueToName[nextOrderValue] || null;
        onSort(orderName);
        change('sort', {
          column: column[RAW],
          order: orderName
        });

        try {
          trackEvent({
            componentName: 'Table',
            eventName: ['sort'].concat(triggerName || []).join('-'),
            eventValue: JSON.stringify({
              orderBy: title,
              orderByType: orderName
            })
          }); // eslint-disable-next-line no-empty
        } catch (_unused) {}
      }

      return _ref4 = {}, _defineProperty(_ref4, ON_TH_CLICK, function () {
        var curOrderIndex = enabledSortDirections.findIndex(function (item) {
          return sortOrderValue === item;
        });
        var nextOrderValue = enabledSortDirections[(curOrderIndex + 1) % enabledSortDirections.length];

        if (nextOrderValue !== sortOrderValue) {
          triggerChange(nextOrderValue, 'title');
        }
      }), _defineProperty(_ref4, TH_TOOLTIP, multiple != null ? "\u7B2C".concat(multipleText[multiple - 1] || multiple, "\u6392\u5E8F") : null), _defineProperty(_ref4, TH_DECORATOR, function (children) {
        function Arrow(className, iconClassName, target) {
          if (!enabledSortDirectionsSet.has(target)) {
            return null;
          }

          return /*#__PURE__*/React.createElement("div", {
            "data-catch": true,
            "data-event-name": "sort",
            className: classNames(className, 'jmtd-table-plugin-sorter-arrow', {
              'jmtd-table-plugin-sorter-arrow-selected': sortOrderValue === target
            }),
            onClick: function onClick() {
              // 下一个箭头值
              var nextValue = sortOrderValue === target ? null : target; // 如果箭头值不在可用范围内，不触发更新

              if (!enabledSortDirectionsSet.has(nextValue)) {
                return;
              }

              triggerChange(nextValue, 'arrow');
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "jmtd-table-plugin-sorter-arrow-icon-wrapper"
          }, /*#__PURE__*/React.createElement("div", {
            className: classNames(iconClassName, 'jmtd-icon-font', 'jmtd-table-plugin-sorter-arrow-icon')
          })));
        }

        return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement("div", {
          className: classNames('jmtd-table-plugin-sorter', {
            'jmtd-table-plugin-sorter-has-hidden-arrow': !enabledSortDirectionsSet.has(1) || !enabledSortDirectionsSet.has(-1)
          })
        }, Arrow('jmtd-table-plugin-sorter-ascend-arrow', 'jmti-caret-up', 1), Arrow('jmtd-table-plugin-sorter-descend-arrow', 'jmti-caret-down', -1)));
      }), _defineProperty(_ref4, TH_PROPS, {
        'data-event-name': 'sort',
        'data-event-content': true
      }), _ref4;
    })
  };
}